// extracted by mini-css-extract-plugin
export var isPrintedCell = "_y3-1";
export var printerIcon = "_y3-0";